export const getNoParamsCurrentUrl = () => window.location.href.split('?')[0]
export const getCurrentURL = (params: Record<string, string>) => {
  const url = new URL(window.location.href)
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })
  return url.toString()
}
